import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { salesByPeriodSearchSchema } from '../../features/reports/operational-search'
import { SalesByPeriodPage } from '../../features/reports/sales-by-period-page'

export const Route = createFileRoute('/_app/sales-by-period')({
  staticData: { crumb: 'salesByPeriod' },
  validateSearch: salesByPeriodSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'sales.read'),
  component: SalesByPeriodPage,
})
